// app/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import profileReducer from '../features/profile/profileSlice';
import audienceReducer from '../features/audience/audienceSlice';
import rolesReducer from '../features/roles/rolesSlice';
import membersReducer from '../features/members/membersSlice';
import memberReducer from '../features/members/memberSlice';
import integrationsReducer from '../features/integrations/integrationsSlice';
import apiKeysReducer from '../features/apicredentials/apiKeysSlice';
import notificationsReducer from '../features/notificationSlider/notificationsSlice';
import templatesReducer from '../features/templates/templatesSlice';
import automationReducer from '../features/automation/automationSlice';
import rejectedTemplatesReducer from '../features/templates/rejectedTemplatesSlice';
import billingReducer from '../features/integrations/billingSlice';
import billingSlice2Reducer from '../features/billing/billingSlice2';
import notificationReducer from '../features/integrations/notificationSlice';



export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    audience: audienceReducer,
    roles: rolesReducer,
    members: membersReducer,
    member: memberReducer,
    integrations: integrationsReducer,
    apiKeys: apiKeysReducer,
    notifications: notificationsReducer,
    templates: templatesReducer,
    automation: automationReducer,
    rejectedTemplates: rejectedTemplatesReducer,
    billing: billingReducer,
    billing2: billingSlice2Reducer,
    notifications2: notificationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
